import { Alert as MaterialAlert, AlertProps } from '@mui/material';
import React from 'react';

const Alert = ({ children, severity }: AlertProps) => {
  return (
    <MaterialAlert
      severity={severity}
      style={{
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)'
      }}
    >
      {children}
    </MaterialAlert>
  );
};

export default Alert;
